import { map, type OperatorFunction } from 'rxjs';
import type { ApiEnvelope } from '../services/super-admin-auth.service';
import { ApiBusinessError } from '../errors/api-business.error';

/**
 * Throws {@link ApiBusinessError} when the HTTP call succeeded but the envelope reports failure,
 * or when `statusCode` is 4xx/5xx (some proxies return HTTP 200 with error payloads).
 */
export function assertSuccessEnvelope<T>(): OperatorFunction<ApiEnvelope<T>, ApiEnvelope<T>> {
  return map((res) => {
    if (res == null || typeof res !== 'object') {
      throw new ApiBusinessError('Invalid server response', 500);
    }
    const code =
      typeof res.statusCode === 'number' && Number.isFinite(res.statusCode)
        ? res.statusCode
        : undefined;
    if (res.status === false || (code !== undefined && code >= 400)) {
      const msg =
        typeof res.message === 'string' && res.message.trim()
          ? res.message.trim()
          : 'Request failed';
      throw new ApiBusinessError(msg, code ?? 400, res);
    }
    return res;
  });
}
